'use strict';

var initialValue = require('./initialValue.cjs');

const getRuntimeEnvWithSafeAccessToWindow = (key) => {
  const browserWindow = window;
  if (typeof browserWindow === "undefined" || browserWindow?.[key] === void 0) {
    return initialValue.runtimeEnvInitialValue;
  }
  return browserWindow[key];
};

exports.getRuntimeEnvWithSafeAccessToWindow = getRuntimeEnvWithSafeAccessToWindow;
//# sourceMappingURL=getRuntimeEnvWithSafeAccessToWindow.cjs.map
